var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctors05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 424.639,
    height: 1166.611,
    viewBox: "0 0 424.639 1166.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.498,
    cy: 0.485,
    r: 2.974,
    gradientTransform: "translate(2.08 120.495) scale(0.143 0.159)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#e9e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#f7f6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefdfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f1c69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f4cea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.094,
    y1: -0.438,
    x2: 1.732,
    y2: 0.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd9b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.496,
    y1: 1.014,
    x2: 0.506,
    y2: 0.234,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0f0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0b0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.494,
    y1: 1.012,
    x2: 0.503,
    y2: 0.235,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.536,
    y1: -0.256,
    x2: 0.469,
    y2: 1.998,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#f8f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 1.878,
    y1: 0.361,
    x2: 2.49,
    y2: 1.43,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.47,
    y1: 1.043,
    x2: 0.538,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.556,
    y1: 1.387,
    x2: 1.1,
    y2: -0.451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 29.826,
    y1: 1.125,
    x2: 29.895,
    y2: 0.111,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.179,
    y1: -0.025,
    x2: 0.944,
    y2: 1.205,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 0.05,
    y1: -0.051,
    x2: 0.876,
    y2: 1.223,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1.772,
    y1: 2.165,
    x2: 0.364,
    y2: 2.017,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.225,
    y1: 2.021,
    x2: 1.27,
    y2: 2.156,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1.495,
    y1: 1.997,
    x2: 0.286,
    y2: 1.17,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.563,
    y1: 0.377,
    x2: 2.077,
    y2: 1.451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.197,
    y1: 1.622,
    x2: 1.278,
    y2: 1.435,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.707,
    y1: 0.048,
    x2: -0.157,
    y2: 1.527,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1.024,
    y1: 0.675,
    x2: -0.003,
    y2: 0.357,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.902,
    y1: 0.965,
    x2: 0.22,
    y2: 0.283,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#fcd7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -0.06,
    y1: 0.519,
    x2: 2.438,
    y2: 0.467,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 2.679,
    y1: 0.523,
    x2: -0.679,
    y2: 0.479,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.489,
    y1: 0.474,
    x2: 0.549,
    y2: 1.042,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#56281e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#652f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 1.047,
    y1: -0.585,
    x2: 0.443,
    y2: 0.87,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.826,
    y1: -0.36,
    x2: 0.491,
    y2: 0.821,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f2c99e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d3aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -0.532,
    y1: -2.728,
    x2: 1.363,
    y2: 2.831,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 1.853,
    y1: -2.308,
    x2: -0.14,
    y2: 1.429,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 0.215,
    y1: 0.564,
    x2: 1.373,
    y2: -0.009,
    xlinkHref: "#linear-gradient-30"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 0.534,
    y1: 1.647,
    x2: 0.49,
    y2: -0.281,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1e1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f0f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.395,
    y1: 1.045,
    x2: 0.56,
    y2: -0.488,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c3c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 0.509,
    y1: -0.189,
    x2: 0.489,
    y2: 1.303,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.621,
    y1: 1.103,
    x2: 0.108,
    y2: -0.283,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.684,
    y1: 1.106,
    x2: 0.128,
    y2: -0.283,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.322,
    y1: -6.657,
    x2: 0.353,
    y2: -5.406,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#337fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.452,
    stopColor: "#3580c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#3f87c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a8ec9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 0.491,
    y1: -1.306,
    x2: 0.567,
    y2: 14.027,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f6cb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565,
    stopColor: "#2175bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#337fc1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 0.179,
    y1: -10.558,
    x2: 0.22,
    y2: -9.118,
    xlinkHref: "#linear-gradient-39"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 0.509,
    y1: 1.943,
    x2: 0.593,
    y2: 14.928,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -0.149,
    y1: 0.481,
    x2: 0.988,
    y2: 0.515,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 0.341,
    y1: 0.89,
    x2: 0.691,
    y2: 0.001,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 1.237,
    y1: 0.892,
    x2: 1.575,
    y2: -0.002,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.445,
    y1: 0.052,
    x2: 0.564,
    y2: 0.984,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 0.95,
    y1: -1.389,
    x2: 0.293,
    y2: 0.98,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#6b3227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#783b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 0.655,
    y1: 0.299,
    x2: 0.164,
    y2: 1.744,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#daa279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#e3af85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.828,
    y1: 0.933,
    x2: 1.604,
    y2: 2.121,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 155.169,
    y1: 6.186,
    x2: 155.325,
    y2: 8.054,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 0.51,
    y1: 0.987,
    x2: 0.469,
    y2: 0.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d3aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f5d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f2c99e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.515,
    cy: 0.49,
    r: 0.443,
    gradientTransform: "translate(0.269 -0.028) scale(1.215 1.058)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b28d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#f7c49d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d3aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 0.439,
    y1: 0.047,
    x2: 0.533,
    y2: 1.028,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c498"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#f2c99e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#f5d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d3aa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.485,
    cy: 0.49,
    r: 0.443,
    gradientTransform: "matrix(-1.22, 0, 0, 1.058, 483.775, -0.028)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -0.011,
    y1: 0.5,
    x2: 0.989,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd8b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d3aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 0.038,
    x2: 1.038,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 0.56,
    y1: -0.606,
    x2: 0.481,
    y2: 0.978,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6d3aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#f2c99e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -0.334,
    y1: 0.5,
    x2: 0.979,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd8b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651,
    stopColor: "#fcd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6d3aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 0,
    x2: 1.134,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 0.509,
    y1: 0.856,
    x2: 0.542,
    y2: 3.99,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 1.076,
    y1: 0.02,
    x2: 0.123,
    y2: 0.871,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1c397"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#f9b28d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c498"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 0.505,
    y1: 1.438,
    x2: 0.5,
    y2: -0.037,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.664,
    y1: 1.168,
    x2: 0.158,
    y2: -1.319,
    xlinkHref: "#linear-gradient-54"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 0.949,
    y1: 0.216,
    x2: 0.027,
    y2: 1.232,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 0.058,
    y1: 0.22,
    x2: 0.989,
    y2: 1.259,
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -1.087,
    y1: -4.761,
    x2: -1.933,
    y2: -4.752,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -2.328,
    y1: -7.72,
    x2: -1.328,
    y2: -7.72,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#f5f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -2.091,
    y1: -4.946,
    x2: -2.727,
    y2: -5.66,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#715241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b89c8c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -3.846,
    y1: 2.484,
    x2: -3.659,
    y2: -4.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b89c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715241"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.633,
    cy: 0.572,
    r: 0.648,
    gradientTransform: "matrix(-0.888, -0.09, -0.073, 0.905, 170.419, 7.588)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -1.987,
    y1: -8.818,
    x2: -0.981,
    y2: -8.818,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a2a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391b13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -1.583,
    y1: -8.821,
    x2: -2.694,
    y2: -7.48,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -2.07,
    y1: -10.04,
    x2: -1.069,
    y2: -10.04,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -2.894,
    y1: -11.783,
    x2: -1.885,
    y2: -11.783,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 213.431,
    y1: 4.664,
    x2: 212.586,
    y2: 4.673,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 240.902,
    y1: 7.016,
    x2: 241.903,
    y2: 7.016,
    xlinkHref: "#linear-gradient-66"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 2.568,
    y1: 4.499,
    x2: 3.146,
    y2: 5.438,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 2.876,
    y1: 12.181,
    x2: 3.063,
    y2: 4.901,
    xlinkHref: "#linear-gradient-67"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.367,
    cy: 0.573,
    r: 0.648,
    gradientTransform: "matrix(0.885, -0.115, 0.093, 0.903, -44.817, -57.935)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 202.105,
    y1: 7.915,
    x2: 203.11,
    y2: 7.915,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 295.549,
    y1: 7.017,
    x2: 294.441,
    y2: 8.37,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 244.454,
    y1: 8.423,
    x2: 245.455,
    y2: 8.423,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 2.283,
    y1: 9.793,
    x2: 3.289,
    y2: 9.793,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#391b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a2a1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -0.219,
    y1: 53.266,
    x2: 0.781,
    y2: 53.266,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 282.092,
    y1: -11.828,
    x2: 283.093,
    y2: -11.828,
    xlinkHref: "#linear-gradient-69"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-46"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 25.124,
    y1: -316.514,
    x2: 25.153,
    y2: -316.514,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#efe4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#faf8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 20.321,
    y1: -339.329,
    x2: 20.343,
    y2: -339.329,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#ebdddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#f6f0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fcfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fbf7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 20.076,
    y1: -238.132,
    x2: 20.101,
    y2: -238.132,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f96e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#f9707f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#ff7d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#f86d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f86d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -0.624,
    y1: 10.118,
    x2: 0.449,
    y2: 10.138,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#eadcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#f6efee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fbf6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -2.486,
    y1: -0.934,
    x2: -1.486,
    y2: -0.934,
    xlinkHref: "#linear-gradient-86"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 0.561,
    y1: -0.15,
    x2: 0.407,
    y2: 1.378,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 0.894,
    y1: 0.149,
    x2: -0.905,
    y2: 2.753,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 0.382,
    y1: 1.152,
    x2: 0.632,
    y2: -0.299,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#783b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#6b3227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 0.475,
    y1: 1.632,
    x2: 0.492,
    y2: 0.823,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7a3c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 0.083,
    y1: 1.32,
    x2: 0.444,
    y2: 0.503,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cb8076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#b76f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.946,
    stopColor: "#86443a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 0.412,
    y1: 0.019,
    x2: 0.836,
    y2: 2.784,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7a3c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -0.439,
    y1: 1.5,
    x2: 0.502,
    y2: 0.47,
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 0.146,
    y1: 2.242,
    x2: 0.644,
    y2: -0.349,
    xlinkHref: "#linear-gradient-92"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 0.255,
    y1: 0.264,
    x2: 2.115,
    y2: 1.818,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#824137"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.054,
    stopColor: "#86443a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#b76f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cb8076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 0.793,
    y1: 0.099,
    x2: -1.181,
    y2: 2.727,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 0.439,
    y1: 1.146,
    x2: 0.619,
    y2: 0.051,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 0.75,
    y1: 1.936,
    x2: 0.251,
    y2: -0.93,
    xlinkHref: "#linear-gradient-95"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -0.155,
    y1: -0.466,
    x2: 0.963,
    y2: 0.812,
    xlinkHref: "#linear-gradient-91"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 0.254,
    y1: 1.601,
    x2: 0.564,
    y2: 0.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.052,
    stopColor: "#6c3328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#783b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445,
    stopColor: "#803f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 0.541,
    y1: 0.316,
    x2: 0.131,
    y2: 2.158,
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 0.599,
    y1: 0.111,
    x2: 0.24,
    y2: 1.313,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 0.286,
    y1: 2.052,
    x2: 0.599,
    y2: 0.217,
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 0.728,
    y1: 1.544,
    x2: 0.342,
    y2: 0.059,
    xlinkHref: "#linear-gradient-47"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: -0.045,
    y1: -1.077,
    x2: 0.494,
    y2: 0.735,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 0.992,
    y1: 2.875,
    x2: 0.413,
    y2: 0.081,
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 1.394,
    y1: 2.348,
    x2: 0.344,
    y2: 0.177,
    xlinkHref: "#linear-gradient-93"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 66.706,
    y1: 0.462,
    x2: 66.89,
    y2: 1.439,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 73.888,
    y1: 0.99,
    x2: 74.888,
    y2: 0.99,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddfe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 116.327,
    y1: 0.78,
    x2: 116.72,
    y2: 2.245,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 136.226,
    y1: 0.998,
    x2: 136.274,
    y2: 2.228,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#eceded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -29.729,
    y1: -6.361,
    x2: -30.641,
    y2: -5.179,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7aaab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#b7babb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7aaab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -16.56,
    y1: -7.946,
    x2: -15.764,
    y2: -7.946,
    xlinkHref: "#linear-gradient-117"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: -0.036,
    y1: 0.142,
    x2: 1.692,
    y2: 1.376,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 0.705,
    y1: 1.112,
    x2: -0.34,
    y2: -2.088,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 0.232,
    y1: -0.036,
    x2: 0.765,
    y2: 1.36,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 0.337,
    y1: 1.311,
    x2: 0.765,
    y2: -0.222,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#f4cea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#f1c69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 0.354,
    y1: 1.331,
    x2: 0.632,
    y2: -0.258,
    xlinkHref: "#linear-gradient-122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 0.469,
    y1: 1.359,
    x2: 0.545,
    y2: -0.188,
    xlinkHref: "#linear-gradient-122"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 0.389,
    y1: -0.335,
    x2: 0.562,
    y2: 0.981,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -0.047,
    y1: 0.858,
    x2: 1.005,
    y2: 0.203,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 0.443,
    y1: -0.331,
    x2: 0.529,
    y2: 0.972,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 0.484,
    y1: -0.295,
    x2: 0.509,
    y2: 0.956,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 0.809,
    y1: 0.142,
    x2: 2.538,
    y2: 1.376,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 9.912,
    y1: 1.112,
    x2: 8.867,
    y2: -2.088,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 1.085,
    y1: 0.475,
    x2: -0.112,
    y2: 0.531,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: -13.084,
    y1: 0.054,
    x2: -11.207,
    y2: -1.075,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#f5d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#f1c69c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c69c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 5.883,
    y1: -0.224,
    x2: 2.179,
    y2: -0.548,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: -43.42,
    y1: -3.071,
    x2: -40.968,
    y2: -3.026,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: -64.879,
    y1: -2.774,
    x2: -59.152,
    y2: -2.702,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: -65.086,
    y1: -2.497,
    x2: -59.232,
    y2: -2.418,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doctors_05",
    "data-name": "Doctors 05",
    transform: "translate(-626 -22.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    transform: "translate(1409.96 -2732.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3018",
    "data-name": "Path 3018",
    d: "M-620.8,3555.91l65.123-.972-.1-47.406-72.094,5.524Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 177.32,
    cy: 25.333,
    rx: 177.32,
    ry: 25.333,
    transform: "translate(-713.961 3871.498)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3019",
    "data-name": "Path 3019",
    d: "M-683.432,3499.68s9.566,52.759,7.971,72.544-4.424,75.475.18,94.527,46.751,128.923,46.852,134.83c.169,9.81,1,26.838,1,26.838l-2.591,61.827,41.8-1.907s1.423-29.039.453-34.09c-4.957-25.83-19.591-89.192-19.591-89.192s-2.255-96.209-4.646-112.33-7.649-43.865-7.649-48.261,4.993-25.508,5.58-32.242c1.159-13.286-.8-68.339-.8-68.339Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3020",
    "data-name": "Path 3020",
    d: "M-587.679,3491.62s20.418,64.707,21.939,71.3,10.955,36.071,15.535,46.832c2.041,4.794,14.989,24.17,16.51,30.032s10.842,55.627,16.924,71.015,33.249,69.531,34.009,82.721.538,33.083.538,33.083l15.872,57.766h41.282l-23.48-65.935s-10.457-42.469-12.164-76.941c-.218-4.392-3.317-49.342-11.4-85-6.17-27.2-23.569-63.019-26.61-76.209s-5.322-97.458-5.322-97.458Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3021",
    "data-name": "Path 3021",
    d: "M-486.012,3781.32c-9.655-24-30.678-62.083-35.124-79.315s-13.861-61.922-15.45-65.123-14-23.1-18.141-36.214-20.54-69.4-20.54-69.4l72.517-8.586,1.342,27.4s-18.689,7.958-54.267,4.861c0,0,13.621,54.423,26.248,68.582C-525.27,3628.18-514.03,3700.8-486.012,3781.32Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3022",
    "data-name": "Path 3022",
    d: "M-614.039,3536.91s1.447,26.8,0,36.836c-.225,1.556-5.8,28.8-5.412,32s9.385,47.4,9.753,52.011,1.452,99.541,3.59,109.379,17.8,84.346,17.8,84.346l-25.008-83.277-6.362-115.815s-8.8-48.449-9.161-50.109-2.527-45.463-2.527-45.463-29.3,1.638-44.615-3.661l-2.677-21.891Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3023",
    "data-name": "Path 3023",
    d: "M-677.212,3602.96s-3.19,48.306.657,62.375,42.307,117.911,42.307,117.911l-33.22-122.556C-668.188,3658.034-677.212,3602.96-677.212,3602.96Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3024",
    "data-name": "Path 3024",
    d: "M-497.875,3583.4s22.19,54.325,27.4,73.47c6.286,23.114,11.166,104.113,13.045,115.759s8.883,45.8,8.883,45.8l5.468,15.355s-9.761-16.691-11.6-20.118-6.886-41.922-6.886-41.922-16.985-109.622-17.444-115.65S-497.875,3583.4-497.875,3583.4Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3025",
    "data-name": "Path 3025",
    d: "M-627.518,3826.6l-3.729,62.177,43.02-.442.453-34.09-5.447,28.117s-32.491.663-32.731,0S-627.518,3826.6-627.518,3826.6Z",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3026",
    "data-name": "Path 3026",
    d: "M-627.518,3826.6s-2.876,15.264-3.849,26.891-6.777,44.351-4.021,49.445,15.934,14.269,29.511,13.4c6.955-.447,19.962-9.331,21.621-13.73,1.793-4.754-1.444-32.023-3.518-48.359l-.915,30.786-41.188.6S-625.9,3848.66-627.518,3826.6Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3027",
    "data-name": "Path 3027",
    d: "M-482.217,3813.67l1.141,21.571,14.231,51.99,43.382-1.328-19.619-52.115,12.2,46.715-32.286.312S-479.915,3831.03-482.217,3813.67Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3028",
    "data-name": "Path 3028",
    d: "M-443.082,3833.79l17.156,50.053-40.485-.138s-8.282-33.1-8.9-35.252c-4.3-14.911-5.706-20.345-6.9-34.781,0,0-2.689,15.269-2.417,17.423,1.094,8.649,6.3,14.126,8.78,32.013s3.007,36.136,5.078,38.026c5.361,4.893,36.216,12.055,47.428,11.41,7.7-.443,3.317-19.718,1.263-27.639C-424.421,3875.9-443.082,3833.79-443.082,3833.79Z",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3029",
    "data-name": "Path 3029",
    d: "M-502.489,3435.7c-.157-69.931-8.406-127.343-15.3-177.018-2.053-14.786-13.225-49.963-16.122-73.532-84.489,11.276-138.677-7.24-154.978-14.591l-.008.015c-31.318,59.405-31,90.992-28.885,134.125.626,12.741,12.166,144.028,12.389,151.322.5,16.417,0,76.1,0,76.1,7.079,9.734,45.065,13.933,53.095,14.015,12.227.126,63.816-.013,112.855-3.143,31.2-1.991,37.457-7.618,37.457-7.618C-501.373,3517.72-502.33,3506.05-502.489,3435.7Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3030",
    "data-name": "Path 3030",
    d: "M-687.933,3228.12c6.4-3.5,76.562,287.972,61.3,296.6s-57.718,3.9-58.381-6.723S-723.109,3247.36-687.933,3228.12Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3031",
    "data-name": "Path 3031",
    d: "M-629.873,3185.77s15.381,2.166,27.018,2.53,23.109.282,29.493-.544l1.112,26.293s-33.292,2.355-60.3-2.354Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3032",
    "data-name": "Path 3032",
    d: "M-574.844,3521.65c4.314,11.614,58.366,7.632,58.073,0-.537-14-11.212-217.867-20.5-228.487S-580.124,3507.43-574.844,3521.65Z",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3033",
    "data-name": "Path 3033",
    d: "M-562.855,3544.27s-23.881-282.347-24.127-289.41-3.812-66.2-3.812-66.2,6.185-.092,14.554-.519l30.153,355.251Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3034",
    "data-name": "Path 3034",
    d: "M-646.055,3546.17s29.151-340.34,29.821-358.785c0,0-10.527-.48-17.25-2.016l-39.54,358.506A172.189,172.189,0,0,0-646.055,3546.17Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 107,
    height: 595,
    transform: "translate(-589 2970.552)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3035",
    "data-name": "Path 3035",
    d: "M-703.538,2988.65l45.717-20.216,30.069,110.972s9.33,49.352,9.426,61.78-35.818,375.325-39.495,423.458c-47.923-5.645-59.7-12.29-64.995-15.412,0,0-3.038-183.326-2.743-192.562s7.6-114.007,9.272-120.518c8.567-33.465,23.687-70.57,23.687-70.57C-678.229,3058.9-703.538,2988.65-703.538,2988.65Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3036",
    "data-name": "Path 3036",
    d: "M-524.734,3032.85s-2.263,14.28-3.294,23.435c-2.513,22.3-1.845,37.672-3.343,46.347,0,0,9.894-10.971,10.236-13.811S-520.6,2995.91-524.734,3032.85Z",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3037",
    "data-name": "Path 3037",
    d: "M-581.536,3086.28l42.011-108.03s16.505,29.007,22.007,30.508c0,0-19.505,3.5-25.507,3.5l22.007,17.5s-65.993,63.574-67.256,105.308Z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3038",
    "data-name": "Path 3038",
    d: "M-692.369,3163.83s6.461-49.055.571-120.346c0,0,8.729,21.984,14.438,35.645S-692.369,3163.83-692.369,3163.83Z",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    "data-name": "Path 3039",
    d: "M-625.548,3097.29l-39.532-117.855s-16.885,28.787-22.406,30.214c0,0,19.458,3.758,25.459,3.838l-22.236,17.213s54.927,60.59,65.859,106.187Z",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    "data-name": "Path 3040",
    d: "M-685.354,3560.67s18.985,4.063,27.533,3.971l21.676-230.482Z",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    "data-name": "Path 3041",
    d: "M-552.9,3564.64s21,.092,26.981-1.075l-49.892-242.4S-561.862,3481.2-552.9,3564.64Z",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    "data-name": "Path 3042",
    d: "M-557.37,3180.05c13.38,2.132,12.311,1.28,29.031,4.782l3.163-19.745H-581.69l-5.029,2.912,1.235,21.34S-570.8,3182.94-557.37,3180.05Z",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    "data-name": "Path 3043",
    d: "M-698.454,3178.14l-6.022,19.374s34.563.377,81.856-5.892c.645-5.851,1.627-18.65,1.627-18.65Z",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    "data-name": "Path 3044",
    d: "M-621.975,3112.28l-.25,11.926s-22.041-1.209-23.814-2.566-27.874-29.064-27.874-29.064l.756-9.595s27.253,24.145,30.131,26.851S-621.975,3112.28-621.975,3112.28Z",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    "data-name": "Path 3045",
    d: "M-670.62,3097.41s-3.425-65.924-5.7-77.088c-1.886-9.282-6.686,57.3-6.686,57.3Z",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    "data-name": "Path 3046",
    d: "M-585.887,3113.48l.588,8.941s41.3,2.163,42.641,1.728,17.215-26.42,17.466-29.545-2.588-9.849-2.588-9.849S-540.8,3110.3-543.668,3112.3C-546.815,3114.5-577.181,3113.78-585.887,3113.48Z",
    fill: "url(#linear-gradient-21)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    "data-name": "Path 3047",
    d: "M-727.8,2967.34s-10.257,7.3-15.866,46.769c-5.01,35.255-3.43,63.688-4.965,80.245-2.267,24.459-8.629,51.309-8.71,80.158-.115,41.256,10.816,77.232,10.816,77.232l14.257,4.663s2.693-25.882,3.628-37.87c.723-9.269,6.364-38.9,10.685-57.031,6.727-28.215,12.891-97.494,11.211-105.4S-705.689,2986.3-727.8,2967.34Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    "data-name": "Path 3048",
    d: "M-707.006,3087.07s-3.813,27.684-4.118,31.741c-2.12,28.171-8.669,52.6-10.373,61.94a531.783,531.783,0,0,0-8.226,80.689l-3.316-7.741s-2.479-61.817,15.2-126.871c2.782-10.239,6.086-40.9,6.086-40.9Z",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    "data-name": "Path 3049",
    d: "M-708.812,3100.32l-39.637-8.193.744-21.164,40.628,13.582a153.479,153.479,0,0,1-1.735,15.775Z",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    "data-name": "Path 3050",
    d: "M-730.228,3263.59c-1.041-3.541-2.811-9.894-2.811-9.894l-19.761-30.464s2.374,32.513,1.4,35.871c-.564,1.95-1.285,4.69-2.082,7.893h24.29C-729.644,3265.49-730.017,3264.31-730.228,3263.59Z",
    fill: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    "data-name": "Path 3051",
    d: "M-745.519,3257.44c-.543.483-2.153,4.307-4.046,9.564h7.507C-740.429,3258.61-740.807,3253.24-745.519,3257.44Z",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    "data-name": "Path 3052",
    d: "M-729.423,3264.54c-1.058-4.519,3.1-51.106,3.1-51.106s-11.566,43.092-6.836,51.024a19.139,19.139,0,0,1,1.2,2.542h3.228C-729.02,3266.05-729.264,3265.22-729.423,3264.54Z",
    fill: "url(#linear-gradient-25)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    "data-name": "Path 3053",
    d: "M-749.849,3105.17s-5.433,34.41-6.042,40.071-3.865,27.547-2.067,43.917,6.757,63.179,6.757,63.179-3.363-72.991-2.858-78.654S-749.849,3105.17-749.849,3105.17Z",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    "data-name": "Path 3054",
    d: "M-647.982,2780.19c26.367-4.351,90.146,15.732,92.64,68.952s1.7,103.4-5.995,111.05-121.207-2.267-123.7-4.276-9.976-46.86-7.482-63.261,8.551-96.733,11.758-101.084S-647.982,2780.19-647.982,2780.19Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3055",
    "data-name": "Path 3055",
    d: "M-676.971,2867.08v4.246a71.341,71.341,0,0,0-3.147,20.8c-.075,13.922,26.306,20.9,22.536,53.794l-45.237,12.511s.885-36.113,2.957-48.857S-676.971,2867.08-676.971,2867.08Z",
    fill: "url(#linear-gradient-28)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3056",
    "data-name": "Path 3056",
    d: "M-569.4,2884.89s-8.755,17.376-10.944,22.24-6.076,17.137-5.35,27.787,7.278,25.279,7.278,25.279h31.787S-548.352,2896.57-569.4,2884.89Z",
    fill: "url(#linear-gradient-29)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3057",
    "data-name": "Path 3057",
    d: "M-598.876,2886.42s0,45.155,5.312,49.138c8.216,6.161,76.684,27.128,79.631,30.489,10.56,12.043,12.008,12.271,14.663,37.5,5.061,48.106-241.5,2.731-239.09,2.952,0,0,6.8-32.888,15.535-37.772s69.613-24.847,74.811-30.017,3.982-44.326,3.982-44.326Z",
    fill: "#f6d3aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3058",
    "data-name": "Path 3058",
    d: "M-592.808,2935.22c-3.441-3.273-3.9-30.21-3.9-30.21s-50.172,2.756-50.95,1.874c.041,3.526.474,23.9.125,26.574-.4,3.062,0,6.687-34.42,14.071,0,0,11.782.782,34.64,1,3.976.038,7.193-6.469,7.652-12.366a58.24,58.24,0,0,0,34.426-8.667c1.21,8.883,2.533,19.808,5.387,21.654s28.448-.923,28.448-.923l3.336-3.285C-575.256,2942.95-589.367,2938.49-592.808,2935.22Z",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3059",
    "data-name": "Path 3059",
    d: "M-628.248,2956.09s-2.552-6.6-6.106-7.486-37.449-1.592-42.055-2.49a186.854,186.854,0,0,0,22.19,4.389C-644.106,2951.68-636.175,2949.92-628.248,2956.09Z",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3060",
    "data-name": "Path 3060",
    d: "M-616.22,2955.5s2.461-5.064,6.833-6.535,37.452-1.047,43.467-.458C-565.92,2948.51-607.746,2950.25-616.22,2955.5Z",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3061",
    "data-name": "Path 3061",
    d: "M-683.284,2948.78l59.429,58.541,59.429-60.782-13.283-4.6-46.146,47.76-43.925-45.825Z",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3062",
    "data-name": "Path 3062",
    d: "M-533.969,3161.24c-2.168-58.037,4.728-66.148,4.728-66.148l58.368-18.3s-32.983-97.481-43.113-113.739c-3.693-5.927-59.891-20.036-59.891-20.036a716.179,716.179,0,0,1-49.005,53.612c-21.7-14.437-49.346-51.28-49.346-51.28s-55.7,13.837-65.373,28.968c-6.419,10.037-29.662,106.578-29.662,106.578,4.744,2.029,36.77.694,55.505,10.659,1.181-8.9-.588-16.162,3.38-26.215,1.027,6.673,6.226,62.7,4.2,98.065-1.991,34.816,1.211,219.446-2.831,256.481l194.853,4.667C-516.45,3390.5-532.694,3195.35-533.969,3161.24Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3063",
    "data-name": "Path 3063",
    d: "M-674.711,2998.81a359.816,359.816,0,0,0,79.3,1.09c43.845-4.243,72.741-2.5,50.819,18.711-25.817,24.984-72.4,36.083-115.977,19.8C-681.278,3030.67-730.865,2992.05-674.711,2998.81Z",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3064",
    "data-name": "Path 3064",
    d: "M-687.279,2949.57l14.977-4.411s23.846,30.144,49.42,51.467c0,0,30.572-32.148,49.005-53.612l10.421,3.267s-33.789,47.027-59.827,67.974C-623.283,3014.26-653.059,2990.52-687.279,2949.57Z",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M-589.091,3033.69s47.838-.63,51.49-.945l.361,8.674-51.851.8Z",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M-690.131,3161.24l-16.332-131.12-2.392,24.087,4.68,109.2s-7.875,48.645-12.988,103.595h9.267C-699.423,3216.45-690.131,3161.24-690.131,3161.24Z",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3067",
    "data-name": "Path 3067",
    d: "M-531.064,3158.62l5.565-96.268-3.341-33.8-15.708,130.066s7.929,56.411,15.669,108.376h9.484C-524.126,3207.64-531.064,3158.62-531.064,3158.62Z",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3068",
    "data-name": "Path 3068",
    d: "M-518.964,3255.17s-31.209,3-54.948,2.727c0,0,.185,3.6.507,9.106h55.369C-518.564,3259.99-518.964,3255.17-518.964,3255.17Z",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3069",
    "data-name": "Path 3069",
    d: "M-573.912,3257.89s31.589.678,52.893-3.2C-521.019,3254.7-558.954,3254.7-573.912,3257.89Z",
    fill: "url(#linear-gradient-40)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3070",
    "data-name": "Path 3070",
    d: "M-668,3258.38s-26.57-.3-47.971-3.628c0,0-.462,5.012-1.068,12.252h48.983C-668.013,3261.77-668,3258.38-668,3258.38Z",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3071",
    "data-name": "Path 3071",
    d: "M-715.973,3254.75s28.454,4.74,47.972,3.628C-668,3258.38-700.129,3254.31-715.973,3254.75Z",
    fill: "url(#linear-gradient-42)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3072",
    "data-name": "Path 3072",
    d: "M-715.973,3254.75l-.736,8.329s26.2,3.53,48.708,3.351v-8.052S-693.957,3258.08-715.973,3254.75Z",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3073",
    "data-name": "Path 3073",
    d: "M-685.021,2948.9s-37.9,7.765-52.472,23.651c-8.66,9.438-30.359,110.732-30.359,110.732l11.889,1.438s29.232-105.47,31.509-109.934C-719.172,2964.43-700.109,2954.08-685.021,2948.9Z",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3074",
    "data-name": "Path 3074",
    d: "M-553.2,2948.9s40.818,7.285,55.393,23.171c8.66,9.438,30.359,110.732,30.359,110.732l-11.889,1.438s-29.231-105.47-31.508-109.934C-516.131,2963.95-538.116,2954.08-553.2,2948.9Z",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M-647.4,2927.73s-.314-19.7-1.377-26.1l52.145,5.627.422,9.354S-617.518,2937.23-647.4,2927.73Z",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M-545.53,2861.04c2.308,4.709,5.71,10.884,8.388,15.389,3.063,5.154,6.1,10.417,7.81,16.2a37.909,37.909,0,0,1,.322,19.339,95.1,95.1,0,0,1-2.666,9.483c-1.024,3.055-2.324,6.007-3.358,9.057a19.335,19.335,0,0,0-.648,10.5c.784,3.676-1.263,7.15.121,10.629-3.434-3.417-2.868-7.826-4.158-12.523-1.761-6.415.677-12.46,2.474-18.563,1.809-6.141,3.848-12.6,3.97-19.052.118-6.243-1.757-12.268-3.992-18.029C-539.927,2876.62-543.828,2868.23-545.53,2861.04Z",
    fill: "url(#linear-gradient-47)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M-667.865,2927.63c-11.774-13.061-23.373-16.759-17.144-34.248,4.651-13.058,13.739-28.333,19.8-47.12,7.482-23.185-13.912,12.06-13.912,12.06A100.663,100.663,0,0,0-703.91,2897.7c-10.51,30.725-3.227,38.58,0,47.018,2.388,6.245,26.469,10.4,13.954,16.1C-666.82,2964.83-656.788,2939.91-667.865,2927.63Z",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M-676.8,2854.48c2.122,17.252,2.728,30.38,2.728,30.38-6.9,0-8.259-7.4-10.955-13.914-4.122-9.965-6.356-20.7,4.5-21.638C-678.7,2849.15-676.8,2854.48-676.8,2854.48Z",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M-678.053,2879.06s-3.379-3.822-2.331-11.338c2.47-17.739-8.778-18.953-6.224-6.846,0,0,1.554-5.709,2.978-4,1.749,2.1-1.877,3.253-.025,12.41C-682.691,2874.04-678.053,2879.06-678.053,2879.06Z",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M-568.758,2854.45c-2.123,17.252-2.728,30.379-2.728,30.379,6.9,0,8.259-7.4,10.955-13.914,4.122-9.964,6.554-20.649-2.828-21.221C-565.189,2849.59-568.758,2854.45-568.758,2854.45Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M-567.505,2879.03s3.379-3.822,2.33-11.338c-2.47-17.739,8.779-18.953,6.225-6.847,0,0-1.555-5.708-2.979-4-1.748,2.1,1.877,3.253.025,12.41C-562.868,2874.01-567.505,2879.03-567.505,2879.03Z",
    fill: "url(#linear-gradient-51)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M-614.479,2777.25c-59.593-.7-56.208,24.745-62.355,61.735-3.449,20.755-2.1,39.276,8.423,54.531,4.264,6.187,9.527,9.175,15.666,14.049,3.9,3.094,9.991,9.73,14.152,12.955,3.8,2.937,7.912,5.3,13,5.5,15.448.587,25.594-11.592,30.035-15.98,15.6-15.416,29.909-21.149,26.767-64.067C-571.259,2812.25-592.959,2777.97-614.479,2777.25Z",
    fill: "#f6d3aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083",
    "data-name": "Path 3083",
    d: "M-597.085,2830.09c-18.3,3.464-17.571,18.051-18.946,35.1,29.555,12.816,46.629-2.287,46.629-2.287s-.086-18.872-4.16-25.346C-575.131,2835.07-579.995,2826.86-597.085,2830.09Z",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084",
    "data-name": "Path 3084",
    d: "M-589.7,2852.37c-8.6,1.856-17.113,12.029-15.238,21.778s7.916,18.113,16.091,21.525c10.687,4.46,18.346-13.658,20.19-31.6C-567.635,2854.19-581.09,2850.51-589.7,2852.37Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085",
    "data-name": "Path 3085",
    d: "M-652.99,2830.92c-7.547-.564-13.761.717-17.659,3.8-9.072,7.19-3.645,27.067-3.645,27.067s14.176,17.515,44.053,5.073C-632.324,2853.35-628.8,2832.71-652.99,2830.92Z",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086",
    "data-name": "Path 3086",
    d: "M-654.807,2854.65c8.606,1.857,17.113,12.029,15.238,21.778s-7.916,18.113-16.09,21.525c-10.688,4.46-19.4-9.595-20.191-31.6C-676.208,2856.43-663.413,2852.8-654.807,2854.65Z",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087",
    "data-name": "Path 3087",
    d: "M-579.593,2861.42c-2.932.781-4.973,2.776-4.576,4.464s3.1,2.425,6.022,1.648,4.972-2.773,4.569-4.465S-576.678,2860.65-579.593,2861.42Z",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088",
    "data-name": "Path 3088",
    d: "M-667.31,2861.87c-2.932-.592-5.556.3-5.863,1.985s1.819,3.544,4.747,4.147,5.565-.3,5.871-1.985S-664.378,2862.47-667.31,2861.87Z",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089",
    "data-name": "Path 3089",
    d: "M-600.606,2774.19s-53.533-15.5-70.126,11.973c-11.683,19.345-10.847,73.385-5.63,92.316,0,0,1.89-21.113,8.95-25.873,0,0-.777-3.492,4.063-30.67,3.668-20.593,21.73-40.921,23.548-40.47,23.659,5.873,21.373,24.688,28.555,34.25,18.645,24.826,41.124,35.341,39.637,48.392,0,0,9.688-27.272,2.956-47.676C-575.021,2797.14-583.51,2777.73-600.606,2774.19Z",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090",
    "data-name": "Path 3090",
    d: "M-622.627,2910.68c-4.077-.221-7.518.814-7.678,2.316s3,2.911,7.082,3.134,7.506-.813,7.673-2.321S-618.561,2910.9-622.627,2910.68Z",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091",
    "data-name": "Path 3091",
    d: "M-573.247,2883.17a63.383,63.383,0,0,1-12.281,15.865c-10.529,10.008-14.867,15.7-16.556,17.38,1.519-1.4,15.547-14.35,19.554-17.338A44.047,44.047,0,0,0-571.609,2885a3.99,3.99,0,0,1-1.638-1.83Z",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092",
    "data-name": "Path 3092",
    d: "M-659.2,2901.16c-20.856-15.9-14.625-44.339-14.625-44.339-10.876,28.867,7.852,41.85,11.638,44.508,7.812,5.48,20.8,16.8,20.8,16.8C-644.3,2915.32-647.712,2909.92-659.2,2901.16Z",
    fill: "#f0c498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093",
    "data-name": "Path 3093",
    d: "M-639.3,2919.95s12.781,17.809,33.894-.818C-605.405,2919.13-622.366,2933.14-639.3,2919.95Z",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094",
    "data-name": "Path 3094",
    d: "M-574.992,2847.13s4.491,10.255,2.914,19.3c-3.416,19.6-14.229,23.358-14.819,36.277,0,0,1.782-1.434,4.367-3.63s9.947-7.823,14.193-21.171-4.6-30.732-6.119-31.651Z",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3095",
    "data-name": "Path 3095",
    d: "M-622.241,2885.42c1.984-.261,9.385-7.56,9.385-7.56l-21.093-.008S-624.224,2885.68-622.241,2885.42Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3096",
    "data-name": "Path 3096",
    d: "M-623.375,2869.04c-5.595.153-7.178,1.572-6.768,3.066,1,3.632,3.375,4.314,6.873,4.3,3.681-.012,6.552-.824,7.117-4.738C-615.985,2870.52-617.769,2868.89-623.375,2869.04Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097",
    "data-name": "Path 3097",
    d: "M-619.612,2878.81s10.281.157,6.959-3.233C-613.771,2874.44-619.612,2878.81-619.612,2878.81Z",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098",
    "data-name": "Path 3098",
    d: "M-633.913,2876.03c-3.435,2.924,7.4,2.769,7.4,2.769S-632.7,2875-633.913,2876.03Z",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099",
    "data-name": "Path 3099",
    d: "M-623.287,2877.45c-10.416-.149-11.6-5.243-13.02-1.975-.583,1.34.528,1.738,2.358,2.384,0,0-.6-1.5,1.739-1.346,1.69.108,3.043,3.7,9.059,3.53,6.424-.184,7.3-3.413,8.952-3.5a1.166,1.166,0,0,1,1.008.32,1.166,1.166,0,0,1,.334,1s3.045-1.575,1.894-2.982C-613.055,2872.32-613.694,2877.58-623.287,2877.45Z",
    fill: "#f0c498"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3100",
    "data-name": "Path 3100",
    d: "M-610.328,2856.08s1.291-7.635,6.922-12.111c7.772-6.178,18.01-2.133,21.742.545,4.2,3.014,3.99,6.385,3.99,6.385s.423,4.782-5.65,8.419a23.22,23.22,0,0,1-13.18,2.843,26.485,26.485,0,0,1-13.824-6.081Z",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3101",
    "data-name": "Path 3101",
    d: "M-609.525,2855.94c2.018-3.55,7.2-9.9,16.324-8.934a15.9,15.9,0,0,1,12.491,7.795s-4.038,4.313-7.921,5.165C-599.872,2862.43-606.266,2858.09-609.525,2855.94Z",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3102",
    "data-name": "Path 3102",
    d: "M-609.525,2855.94s7.236-5.652,14.856-5.05c7.761.614,10.53,3.125,12.928,5.092,0,0,.347-.369,1.031-1.181,0,0-3.2-7.437-15.556-8C-600.223,2846.62-607.321,2851.93-609.525,2855.94Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3103",
    "data-name": "Path 3103",
    d: "M-586.883,2853.97a8.684,8.684,0,0,0-9.138-8.192,8.684,8.684,0,0,0-8.621,8.734,6.336,6.336,0,0,0,2.735,5.228c4.13,1.292,7.789,1.719,11.628.768A6.863,6.863,0,0,0-586.883,2853.97Z",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3104",
    "data-name": "Path 3104",
    d: "M-604.547,2853a17.781,17.781,0,0,1,17.494-.453,8.719,8.719,0,0,0-3.618-5.75h-10.114A9.542,9.542,0,0,0-604.547,2853Z",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3105",
    "data-name": "Path 3105",
    d: "M-601.877,2852.95c-.324,2.854,2.024,5.4,5.223,5.693s6.058-1.8,6.373-4.645-2.026-5.4-5.23-5.689S-601.569,2850.09-601.877,2852.95Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3106",
    "data-name": "Path 3106",
    d: "M-609.525,2855.94s3.456-7.894,15.2-7.769c9.138.1,13.274,6.9,14.275,6.752,4.041-.595,4.3-5.711,4.286-6.214-4.291,1.9-10.164-4.887-17.853-4.959C-603.013,2843.67-608.942,2849.5-609.525,2855.94Z",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3107",
    "data-name": "Path 3107",
    d: "M-608.448,2850.52a16.474,16.474,0,0,1,6.3-7.78c3.3-2.153,10.174-3.594,17.243-.034,0,0-9.438-3.3-15.5.189a23.947,23.947,0,0,0-8.043,7.625Z",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3108",
    "data-name": "Path 3108",
    d: "M-609.525,2855.94s4.008-7.618,14.338-7.512a21.392,21.392,0,0,1,14.1,5.972s-3.888-6.819-13.66-7.016C-600.767,2847.26-606.394,2848.88-609.525,2855.94Z",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3109",
    "data-name": "Path 3109",
    d: "M-595.5,2853.62a1.362,1.362,0,0,1-.758.741,1.362,1.362,0,0,1-1.06-.028,1.429,1.429,0,0,1-.658-1.885,1.363,1.363,0,0,1,.761-.739,1.363,1.363,0,0,1,1.06.031,1.432,1.432,0,0,1,.655,1.88Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M-590.237,2855.26a1.9,1.9,0,0,1-2.5.908,1.863,1.863,0,0,1-.983-1.043,1.862,1.862,0,0,1,.049-1.432,1.9,1.9,0,0,1,2.505-.9,1.854,1.854,0,0,1,.982,1.042,1.854,1.854,0,0,1-.053,1.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M-580.054,2854.93c.556-.539-1.572-.917-1.3-1.216-3.176,4.775-8.549,6.619-13.186,7.311a17.974,17.974,0,0,0,11.153-3.327h0c4.044.57,7.119-3.6,7.119-3.6C-578.972,2856.07-580.054,2854.93-580.054,2854.93Z",
    fill: "url(#linear-gradient-72)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M-636.146,2855.99s-1.336-7.627-6.993-12.07c-7.808-6.133-18.022-2.028-21.738.671-4.184,3.038-3.953,6.407-3.953,6.407s-.4,4.785,5.7,8.386a23.23,23.23,0,0,0,13.2,2.768,26.5,26.5,0,0,0,13.784-6.162Z",
    fill: "url(#linear-gradient-73)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M-636.95,2855.85c-2.039-3.537-7.262-9.855-16.376-8.838a15.893,15.893,0,0,0-12.445,7.867s4.062,4.29,7.95,5.119C-646.566,2862.4-640.2,2858.02-636.95,2855.85Z",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M-636.95,2855.85s-7.269-5.609-14.885-4.963c-7.758.659-10.513,3.186-12.9,5.167,0,0-.349-.367-1.037-1.175,0,0,3.159-7.455,15.509-8.095C-646.307,2846.58-639.178,2851.85-636.95,2855.85Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3115",
    "data-name": "Path 3115",
    d: "M-659.6,2854.01a8.681,8.681,0,0,1,9.089-8.244,8.682,8.682,0,0,1,8.672,8.683,6.245,6.245,0,0,1-2.875,5.3,20.721,20.721,0,0,1-11.452.784A6.862,6.862,0,0,1-659.6,2854.01Z",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3116",
    "data-name": "Path 3116",
    d: "M-641.946,2852.94a17.78,17.78,0,0,0-17.5-.351,9.562,9.562,0,0,1,3.585-5.772l8.954.455a6.476,6.476,0,0,1,4.961,5.668Z",
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3117",
    "data-name": "Path 3117",
    d: "M-644.616,2852.9c.341,2.852-1.992,5.41-5.189,5.723s-6.069-1.759-6.4-4.608,1.994-5.413,5.2-5.719S-644.94,2850.05-644.616,2852.9Z",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3118",
    "data-name": "Path 3118",
    d: "M-636.95,2855.85s-3.59-7.9-15.33-7.7c-9.137.15-13.145,7-14.147,6.859-4.044-.571-4.913-6.1-4.9-6.6,4.614,2.7,10.717-4.535,18.406-4.652C-643.533,2843.61-637.571,2849.41-636.95,2855.85Z",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3119",
    "data-name": "Path 3119",
    d: "M-638.059,2850.44a16.466,16.466,0,0,0-6.346-7.743c-3.315-2.134-10.2-3.535-17.243.065,0,0,9.419-3.359,15.505.1A23.941,23.941,0,0,1-638.059,2850.44Z",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3120",
    "data-name": "Path 3120",
    d: "M-636.95,2855.85s-4.052-7.595-14.382-7.429a21.4,21.4,0,0,0-14.06,6.055s3.848-6.842,13.619-7.1C-645.759,2847.23-640.123,2848.81-636.95,2855.85Z",
    fill: "url(#linear-gradient-79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3121",
    "data-name": "Path 3121",
    d: "M-649.207,2853.66a1.391,1.391,0,0,1-.8.721,1.391,1.391,0,0,1-1.078-.072,1.463,1.463,0,0,1-.592-1.944,1.39,1.39,0,0,1,.808-.721,1.388,1.388,0,0,1,1.08.078,1.454,1.454,0,0,1,.586,1.938Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3122",
    "data-name": "Path 3122",
    d: "M-643.929,2855.51a1.934,1.934,0,0,1-2.589.817,1.9,1.9,0,0,1-.952-1.1,1.9,1.9,0,0,1,.108-1.452,1.928,1.928,0,0,1,2.588-.818,1.9,1.9,0,0,1,.953,1.1A1.9,1.9,0,0,1-643.929,2855.51Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3123",
    "data-name": "Path 3123",
    d: "M-651.837,2861c-4.64-.666-10.1-2.46-13.3-7.217.276.3-1.85.688-1.291,1.224l.053.049c-.246.194-1.366.856-3.738-.851,0,0,3.054,4.079,7.049,3.561A18.159,18.159,0,0,0-651.837,2861Z",
    fill: "url(#linear-gradient-80)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3124",
    "data-name": "Path 3124",
    d: "M-602.04,2830.58c-4.044,1.839-6.995,7.1-3.49,5.993a134.674,134.674,0,0,1,19.282-3.232c4.379-.042,10.809,2.331,12.5,3.41,0,0-6.43-6.169-11.242-6.719S-599.863,2829.59-602.04,2830.58Z",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3125",
    "data-name": "Path 3125",
    d: "M-644.535,2830.5c4.09,1.752,6.473,6.594,2.944,5.567s-16.59-2.791-19.4-2.905c-3.988-.164-10.757,2.672-12.426,3.787,0,0,6.293-6.438,11.093-7.1S-646.729,2829.56-644.535,2830.5Z",
    fill: "url(#linear-gradient-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3126",
    "data-name": "Path 3126",
    d: "M-648.133,2889.4c-1.351-.445-2.111-1.522-1.552-2.559.491-.929,6.194,3.055,8.4,6.188A24.991,24.991,0,0,0-648.133,2889.4Z",
    fill: "#f0c498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3127",
    "data-name": "Path 3127",
    d: "M-597.755,2888.69c1.314-.556,1.975-1.692,1.334-2.678-.567-.883-5.911,3.56-7.84,6.867a24.933,24.933,0,0,1,6.506-4.189Z",
    fill: "#f0c498"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3128",
    "data-name": "Path 3128",
    d: "M-635.988,2899.93c2.581,5.437,16.642,12.952,26.917-.285C-609.071,2899.64-623.733,2906.3-635.988,2899.93Z",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3129",
    "data-name": "Path 3129",
    d: "M-624.2,2890.54a106.846,106.846,0,0,1-24.038-2.666v.029a3.367,3.367,0,0,1,.23.332,26.446,26.446,0,0,1,6.009,2.936c1.676,1.194,3.362,9.307,19.782,9.028,8.968-.156,14.368-3.251,19.625-9.421a14.205,14.205,0,0,1,4.514-3.3c.033-.15.1-.216.14-.373C-601.535,2888.15-608.737,2890.62-624.2,2890.54Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3130",
    "data-name": "Path 3130",
    d: "M-609.4,2891.9c-9.2,2.133-21.739,1.952-26.284,1.148-2.646-1.151-2.369,2.2-2.369,2.2,5.808,5.885,10.438,4.742,15.084,4.83,4.583.095,11.412-1.8,15.45-5.439C-607.131,2893.54-608.118,2891.6-609.4,2891.9Z",
    fill: "url(#linear-gradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M-605.34,2888.46s-2.995,1.481-10.051,2.272c-7.115.8-10.117.387-16.518.122a40.726,40.726,0,0,1-8.417-1.392,9.149,9.149,0,0,1,1.124,1.825c.569,1.285,3.373,5.636,16.59,5.393,9.945-.182,15.162-3.756,15.857-5.908C-606.336,2889.47-605.414,2888.89-605.34,2888.46Z",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M-621.346,2899.59c-20.193.1-13.222-8.191-26.668-11.358a24.862,24.862,0,0,1,6.659,5.69c3.932,4.485,7.336,11.569,18.652,11.407,10.208-.158,15.786-7.626,19.022-11.731,3.706-4.692,5.558-6.1,5.643-6.122C-608.984,2890.54-605.3,2898.99-621.346,2899.59Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3133",
    "data-name": "Path 3133",
    d: "M-633.3,2897.8c-3.115-1.574-5.906-4.941-6.491-5.37.737.987,5.175,11.657,16.544,11.341,13.145-.366,15.465-9.206,17.8-11.844-1.1,1.177-3.869,4.342-7.291,5.548a38.347,38.347,0,0,1-10.3,1.958A27.6,27.6,0,0,1-633.3,2897.8Z",
    fill: "url(#linear-gradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3134",
    "data-name": "Path 3134",
    d: "M-613.134,2898.8c.172.461-1.079,2-3.752,2.767-3.441.991-6.177.079-6.357-.382s4.391-.811,5.716-1.279S-613.309,2898.34-613.134,2898.8Z",
    fill: "#ff9aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3135",
    "data-name": "Path 3135",
    d: "M-647.791,2889.01c.8.358,1.413-.252,4.589.878,0,0-5.414-2.778-5.771-2.615C-649.219,2887.39-648.975,2888.48-647.791,2889.01Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3136",
    "data-name": "Path 3136",
    d: "M-598.019,2888.28c-.79.386-1.68-.191-4.435,1.068,0,0,5.119-3.137,5.561-2.842C-596.667,2886.66-596.855,2887.71-598.019,2888.28Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M-640.042,2889.77l.868,1.567s5.741,3.04,17.481,2.931a36.774,36.774,0,0,0,14.889-3.35l.658-1.568Z",
    fill: "url(#linear-gradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M-622.4,2889.03c-3.279-.029-18.321.214-24.752-1.077,0,0,2.4,1.451,14.246,3.666a46.825,46.825,0,0,0,10.278,1.209c4.331,0,7.92-.929,11.273-1.52a56.916,56.916,0,0,0,12.422-3.994C-601.967,2888.19-619.739,2889.06-622.4,2889.03Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M-635.572,2889.75c.11-.413,5.979-.172,6.945-.176s10.023.1,11.016.072c1.4-.039,8.119-.429,8.058.067s-10.428,1.815-11.652,1.928S-635.89,2890.97-635.572,2889.75Z",
    fill: "url(#linear-gradient-88)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M-641.493,2770.16c3.121-9.336,36.429-22.245,72.1,10.819,20.41,18.917,23.192,47.616,20.807,66.366-1.516,11.92,21.021,43.1,11.4,66.9,0,0,17.449,56.7-31.415,51.3,0,0,20.842-4.719-3.71-29.924-4.078-4.187-11.5-9.427-11.645-19.193-.2-13.076,25.384-35.7,17.5-66.436-2.71-10.569-31.7-31.836-40.484-52.346-11-25.677-32.863-16.167-32.863-16.167S-640.218,2777.48-641.493,2770.16Z",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M-560.934,2939.98c11.651,14.689,11.389,26.568-7.665,25.556C-559.384,2965.54-552.079,2958.41-560.934,2939.98Z",
    fill: "url(#linear-gradient-90)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3142",
    "data-name": "Path 3142",
    d: "M-692.7,2799.56c-7.839,19.7-5.719,27.69-5.719,36.532s3.684,15.207-7.858,36.581c-6.623,12.264-2.2,24.125,1.311,36.015-3.887,6.529.372-12.031,16.534-40.841,9.348-14.375,14.54-17.829,16.38-35.441,4.183-40.053,32.246-50.933,32.246-50.933l-.958-11.56C-658.377,2756.61-684.857,2779.85-692.7,2799.56Z",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3143",
    "data-name": "Path 3143",
    d: "M-639.8,2781.47c28.558-1.851,31.347,24.76,39.681,36.4s33.791,29.133,31.783,42.558c-2.726,18.216-10.454,42.353-10.536,51.072-.133,14.266,7.059,16.59,13.718,23.572,12.405,13,16.57,29.024,2.909,37.478,0,0,47.5-6.885,30.065-42.89-10.707-22.106-35.162-15.013-35.013-37.02.058-8.608,27.085-49.121.74-62.71C-596.6,2814.37-611.789,2758.58-639.8,2781.47Z",
    fill: "url(#linear-gradient-92)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3144",
    "data-name": "Path 3144",
    d: "M-708.971,2866.13c-4.558,6.089-9.053,12.9-9.5,20.731-.431,7.587,2.419,14.558,6.182,21,.73,1.252,1.5,2.482,2.275,3.7a4.694,4.694,0,0,1,2.611-2.294c-1.319-3.09-2.633-6.183-3.69-9.368a32.1,32.1,0,0,1-1.9-10.5,24.533,24.533,0,0,1,2.324-9.84c3.012-6.64,7.716-12.5,11.795-18.5s10.258-17.082,11.154-36.264C-691.945,2847.43-704.321,2859.92-708.971,2866.13Z",
    fill: "url(#linear-gradient-93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3145",
    "data-name": "Path 3145",
    d: "M-575.494,2775.74c15.777,11.873,19.258,21.091,24.594,34.423,3.142,7.852,4.1,16.1,3.876,24.514-.231,8.663-1.483,17.27-1.529,25.94a67.26,67.26,0,0,0,5.632,27.46A42.656,42.656,0,0,1-551.674,2871c-2.055-7.531-2.152-15.408-1.787-23.155.382-8.1,1.239-16.239.484-24.343a60.78,60.78,0,0,0-7.7-23.669C-565.233,2791.56-569.609,2783.08-575.494,2775.74Z",
    fill: "url(#linear-gradient-94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3146",
    "data-name": "Path 3146",
    d: "M-634.957,2776.79c.845-5.466,5.553-9.347,10.9-10.172,6.76-1.045,13.292,2.278,18.183,6.69,5.122,4.619,9.192,10.408,13.1,16.049,4.01,5.791,7.838,11.723,12.244,17.227,4.433,5.538,9.913,11.706,17.341,12.763-5.25,1.255-10.707-1.289-14.868-4.31-5.336-3.875-9.745-8.991-13.675-14.243-4.041-5.4-7.657-11.1-11.556-16.6-3.726-5.257-7.87-10.824-13.927-13.525a14.5,14.5,0,0,0-10.763-.75A11.184,11.184,0,0,0-634.957,2776.79Z",
    fill: "url(#linear-gradient-95)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M-641.285,2769.63c-.153-3.859,2.014-7.01,4.864-9.567a19.175,19.175,0,0,1,12.752-4.506,47.083,47.083,0,0,1,14.5,2.659,84.493,84.493,0,0,1,13.5,5.535,68.946,68.946,0,0,1,13.045,8.656,59.756,59.756,0,0,1-9.722-2.595c-3.821-1.2-7.615-2.49-11.414-3.76-4.386-1.467-8.772-2.984-13.22-4.254-4.515-1.289-9.44-2.347-14.095-1.146C-635.6,2761.82-640.295,2764.87-641.285,2769.63Z",
    fill: "url(#linear-gradient-96)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M-533.6,2918.48c-7.335-11.312-21.146-19.595-24.969-33.056-2.616-9.21,1.69-22.437,3.417-32.063-6.507,12.7-11.776,26.9-5.1,40.183,6.416,12.766,21.652,20.626,24.982,34.989,4.844,20.889-2.263,38.017-26.976,44.014C-526.931,2969.28-520.555,2939.31-533.6,2918.48Z",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M-641.285,2769.63c-14.369-9.776-32.488,7.708-40.945,18.31-10.49,13.15-17.212,31.357-16.184,48.15-.844-10.32-.87-19.225.857-27.759,1.795-8.875,4.857-16.745,10.7-23.641C-677.9,2774.12-654.313,2755.48-641.285,2769.63Z",
    fill: "url(#linear-gradient-98)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M-589.1,2809.74s12,13.6,18.236,17.188c6.8,3.915,15.8,7.489,15.8,20.2,0,0-2.8-9.546-9.271-13.347S-579.526,2827.67-589.1,2809.74Z",
    fill: "url(#linear-gradient-99)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3151",
    "data-name": "Path 3151",
    d: "M-568.925,2903.34c-.787,16.107,14.182,19.852,18.648,25.189,5.464,6.53,9.542,15.15,3.484,21.118C-542.388,2926.96-578.912,2928.86-568.925,2903.34Z",
    fill: "url(#linear-gradient-100)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3152",
    "data-name": "Path 3152",
    d: "M-580.346,2838.48c21.736,18.069,14.49,32.542,6.175,49.845-4.432,9.222-10.136,17.354-9.736,26.954.329,7.9,4.1,16.521,17.2,22.535-22.769-4.269-26.256-26.329-13.179-48.448C-567.933,2869.14-565.608,2857.78-580.346,2838.48Z",
    fill: "url(#linear-gradient-101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3153",
    "data-name": "Path 3153",
    d: "M-559.717,2813.57c-9.519-16.075-20.014-28.333-32.884-38.587C-569,2784.82-563.07,2796.74-559.717,2813.57Z",
    fill: "url(#linear-gradient-102)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3154",
    "data-name": "Path 3154",
    d: "M-639.8,2781.47s16.119-2.968,28.558,14.775C-611.243,2796.25-621.215,2774.2-639.8,2781.47Z",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3155",
    "data-name": "Path 3155",
    d: "M-680.122,2851.81c.351.383.893,11.68,1.923,17.06,0,0,.756-12.943,3.144-21.808Z",
    fill: "url(#linear-gradient-104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3156",
    "data-name": "Path 3156",
    d: "M-639.84,2781.47s-29.333,2.454-31.688,39.121c-1.259,19.6,1.307,32.848-15.191,55.184-8.271,11.2-12.86,16.526-16.4,28.879-5.765,20.124,23.016,26.746,25.064,41.36,1.7,12.148-3.868,24.918-28.447,25.939,8.272-1.368,9.048-11.1,6.638-16.841-1.413-3.366-6.767-6.289-12.675-12.076-29.136-28.543,10.911-56.71,18.159-71.571s7.014-16.794,9.184-32.918c1.073-7.966,1.122-30.3,7.1-39.909S-661.9,2777.72-639.84,2781.47Z",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3157",
    "data-name": "Path 3157",
    d: "M-673.039,2791.76s-8.753,8.375-9.482,19.549-1.881,18.039-2.673,27.236c-.583,6.768-7.885,32.6-15.928,43.095,0,0,20.132-21.631,19.873-46.52S-678.693,2801.39-673.039,2791.76Z",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3158",
    "data-name": "Path 3158",
    d: "M-672.254,2836.87c-1.416,30.565-12.2,26.712-17.771,57.221-3.513,19.231,14.916,35.751-10.281,42.8,19.691-4.991,1.26-30.764,2.664-44.489C-695.251,2869.04-677.481,2869.07-672.254,2836.87Z",
    fill: "url(#linear-gradient-107)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3159",
    "data-name": "Path 3159",
    d: "M-709.176,2926.82c-.2,31.089,7.08,38.866,27.024,42.165C-711.419,2972.06-718.512,2954.48-709.176,2926.82Z",
    fill: "#824137"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3160",
    "data-name": "Path 3160",
    d: "M-699.862,2920.77s6.839,7.06,15.632,14.858c3.508,3.11,8.993,10.629,6.177,19.982s-10.374,16.338-28.447,16.338c0,0,22.371-3.535,23.706-16.841S-691.412,2932.9-699.862,2920.77Z",
    fill: "url(#linear-gradient-108)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3161",
    "data-name": "Path 3161",
    d: "M-702.8,2891.67c-4.84,10.3-13.232,26.31-7.874,37.362,4.63,9.548,32.757,16.04,16.363,31.164,6.035-15.655-11.081-15.378-18.035-24.246C-725.775,2918.83-708.995,2907.2-702.8,2891.67Z",
    fill: "url(#linear-gradient-109)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3162",
    "data-name": "Path 3162",
    d: "M-675.133,2932.54c7.439,5.763,9.7,22.288-2.147,25.014C-671.429,2951.64-671.1,2938.21-675.133,2932.54Z",
    fill: "url(#linear-gradient-110)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3163",
    "data-name": "Path 3163",
    d: "M-618.728,2787.42c-.089-.054-.135-.077-.135-.077Z",
    fill: "url(#linear-gradient-111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3164",
    "data-name": "Path 3164",
    d: "M-594.6,2818.55c-13.129-16.66-7.979-22.174-24.124-31.135.849.509,5.6,3.77,11.107,15.732,2.425,5.264,4.475,11.885,10.483,18.357,1.44,1.55,2.768,2.965,4,4.265h0l.009.01c9.3,9.826,12.785,12.693,12.785,12.693C-585.4,2832.96-587.475,2827.6-594.6,2818.55Z",
    fill: "url(#linear-gradient-112)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3165",
    "data-name": "Path 3165",
    d: "M-587.627,3035.46a14.825,14.825,0,0,0,14.589,15.061,14.824,14.824,0,0,0,14.977-14.671,14.828,14.828,0,0,0-14.588-15.063,14.831,14.831,0,0,0-14.978,14.673Z",
    fill: "url(#linear-gradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3166",
    "data-name": "Path 3166",
    d: "M-585.762,3034.98a13.3,13.3,0,0,0,13.084,13.507,13.3,13.3,0,0,0,13.435-13.157,13.3,13.3,0,0,0-13.081-13.509,13.3,13.3,0,0,0-13.438,13.159Z",
    fill: "url(#linear-gradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3167",
    "data-name": "Path 3167",
    d: "M-568.454,3021.11c7.821-37.54,11.262-83.579-26.475-92.337a21.228,21.228,0,0,0,.886,3.959c38.958,11.013,25.646,70.11,21.794,87.992-.363,1.774-1.761,3.882-1.511,6.179s3.25,3.167,4.4,1.275S-568.757,3022.47-568.454,3021.11Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3168",
    "data-name": "Path 3168",
    d: "M-579.352,3034.76a8.481,8.481,0,0,0,9.007,7.917,8.476,8.476,0,0,0,7.823-9.088,8.478,8.478,0,0,0-9.006-7.913A8.479,8.479,0,0,0-579.352,3034.76Z",
    fill: "url(#linear-gradient-115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3169",
    "data-name": "Path 3169",
    d: "M-577.494,3033.93a7.173,7.173,0,0,0,7.686,6.6,7.14,7.14,0,0,0,4.917-2.409,7.14,7.14,0,0,0,1.765-5.183,7.175,7.175,0,0,0-7.686-6.6,7.141,7.141,0,0,0-4.917,2.408A7.14,7.14,0,0,0-577.494,3033.93Z",
    fill: "url(#linear-gradient-116)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3170",
    "data-name": "Path 3170",
    d: "M-662.41,3017.44s12.641,53.264-20.423,54.756c0,0-1.722,2.854,3.06,3s31.693-7.132,20.9-58.5Z",
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3171",
    "data-name": "Path 3171",
    d: "M-678.487,3022s15.47,52.513,44.915,37.39c0,0,2.909,1.623-1.17,4.129s-31.048,9.543-47.177-40.406Z",
    fill: "url(#linear-gradient-118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3172",
    "data-name": "Path 3172",
    d: "M-636.095,3060.66s3.051-3.265,4.087-2.781,2.52,4.506,2.094,5.161-3.686,1.01-4.957.773A12.632,12.632,0,0,1-636.095,3060.66Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3173",
    "data-name": "Path 3173",
    d: "M-677.755,3074.95s-3.809,2.334-4.681,1.586-1.223-5.013-.64-5.529,3.827.012,4.988.582A12.578,12.578,0,0,1-677.755,3074.95Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3174",
    "data-name": "Path 3174",
    d: "M-647.4,2928.66c-33.3,7.962-34.55,47.808-32.591,61.135-12.362,6.237-2.68,34.823-2.264,35s4.673-1.242,4.989-1.808-11.1-27.158.088-29.179c12.262-2.209,14.158,25.976,14.385,26.426s5.429-.361,5.739-.93-4.622-29.94-19.3-30.132c-1.454-11.04,2.674-50.01,28.874-56.356C-647.354,2931.87-647.407,2929.84-647.4,2928.66Z",
    fill: "#023c74"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3175",
    "data-name": "Path 3175",
    d: "M-707.321,3095.57s-53.336-10.8-60.531-12.292l2.119-9.675,58.6,13.369Z",
    fill: "url(#linear-gradient-119)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3176",
    "data-name": "Path 3176",
    d: "M-706.694,3095.73l.519-71.405-11.166,69.22Z",
    fill: "url(#linear-gradient-120)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3177",
    "data-name": "Path 3177",
    d: "M-501.925,3228.7s26.58-42.181,29.939-51.917,3.387-16.045,1.932-28.46c-1.812-15.456-8.7-69.312-8.7-69.312l-38.755,12.814s9.011,52.507,10.131,59.759-2.06,39.759-2.06,39.759-9.587,18.721-11.34,22.18-11.34,8.911-11.34,8.911-11.926.7-14.893,2.583-14.207,13.507-17.849,17.29c-5.549,5.764-16.736,13.229-10.673,16.73,3.252,1.878,12.083-6.49,12.083-6.49l7.626-5.461s-3.8,9.706-3.56,10.019c1.372,1.794,10.365-1.556,16.4.234,9.334,2.768,20.733,2.587,20.733,2.587Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3178",
    "data-name": "Path 3178",
    d: "M-507.2,3153.53s9.718-12.026,29.511-.189c2.452,1.467-6.562-4.565-13.926-15.49s-15.648-42.155-15.648-42.155l-10.209.761S-509.452,3139.09-507.2,3153.53Z",
    fill: "url(#linear-gradient-121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3179",
    "data-name": "Path 3179",
    d: "M-507.4,3164.9l-2.8,26.122s-8.939,20.593-11.1,22.971c-3.086,3.393-10.811,8.443-10.811,8.443s16.678-6.714,19.179-11.641,8.284-18.622,8.284-19.773C-504.657,3187.14-507.4,3164.9-507.4,3164.9Z",
    fill: "url(#linear-gradient-122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3180",
    "data-name": "Path 3180",
    d: "M-497.535,3221.66c-19.718,31.615-24.714,38.268-24.714,38.268l-4.522-.227,14.643-19.161S-502.41,3227.96-497.535,3221.66Z",
    fill: "url(#linear-gradient-123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3181",
    "data-name": "Path 3181",
    d: "M-576.88,3257.86s1.089,3.187,5.724.909c3.171-1.558,15.33-11.68,15.33-11.68s-8.3,10.954-8.153,11.254c.72,1.464,10.982-1.994,17.679.767,11.858,4.889,24.051.819,24.051.819l4.671-6.838s-25.775,2.344-39.569,2.079c0,0,7.415-13.8,8.17-15.173s-3.479,1.715-7.985,5.935S-574,3260.79-576.88,3257.86Z",
    fill: "url(#linear-gradient-124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3182",
    "data-name": "Path 3182",
    d: "M-571.907,3251.29c-.934-.575-6,2.987-6.045,4.222-.039,1.077,1.836,3.7,2.582,3.593,1.594-.236,4.743-3.307,5.211-4.628S-570.839,3251.95-571.907,3251.29Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3183",
    "data-name": "Path 3183",
    d: "M-484.312,3088.74a30.09,30.09,0,0,1,6.62-1.4l7.894,63.253S-481.728,3104.99-484.312,3088.74Z",
    fill: "url(#linear-gradient-125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3184",
    "data-name": "Path 3184",
    d: "M-518.443,3092.23l1.787,8.6s17.142-6.365,39.1-12.407l-1.2-9.405Z",
    fill: "url(#linear-gradient-126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3185",
    "data-name": "Path 3185",
    d: "M-486.554,3154.48c7.511-.734,12.56,7.423,14.817,11.911s-25.367,53.113-29.408,56.078,1.214-61.958,4.829-64.98S-488.551,3154.68-486.554,3154.48Z",
    fill: "url(#linear-gradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3186",
    "data-name": "Path 3186",
    d: "M-569.509,3246.73s20.526-20.91,22.5-21.709,5.534-2.167,14.893-2.583a46.23,46.23,0,0,0-15.363,5.6C-554.528,3232.39-569.509,3246.73-569.509,3246.73Z",
    fill: "url(#linear-gradient-128)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3187",
    "data-name": "Path 3187",
    d: "M-527.983,3095.09s53.336-10.8,60.531-12.292l-2.118-9.675-58.6,13.369Z",
    fill: "url(#linear-gradient-129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3188",
    "data-name": "Path 3188",
    d: "M-528.609,3095.25l-.519-71.405,11.166,69.22Z",
    fill: "url(#linear-gradient-130)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3189",
    "data-name": "Path 3189",
    d: "M-518.964,3255.17s-34.245,2.265-50.647,2.666a9.007,9.007,0,0,1-4.207,1.762l.349,6.3s18.293.8,55.132-2.845Z",
    fill: "url(#linear-gradient-131)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3190",
    "data-name": "Path 3190",
    d: "M-747.606,3247.1s-6.279,23.216-11.64,30.8-11.687,20.906-14.1,24.369-11.339,27.728-8.816,28.693,7.746-6.984,9.954-14.429c3.1-3.3,9.507-17.52,9.507-17.52s-2.8,14.372-3.675,17.963c-.6,2.446,4.088,10.14,5.373,12.723s11.845,7.942,13.411,5.808c1.489-2.032-1.449-4.189-7.872-9.733-.1-2.765-1.14-6.192-2.908-7.93,3.072-3.2,4.671-10.437,4.671-10.437s1.718,12.1,4.778,15.63,15.611,9.348,16.1,8.729c2.682-3.4-4.971-10.4-11.18-13.7l1.234-16.221s4.031,12.383,5.767,14.827,13.207,7.144,16.554,8.446c2.556-2.756.691-4.077-11.765-11.913,0,0,.024-10.144-.467-16.426,0,0,8.466-19.612,4-32.164-3.217-9.059-4.252-21.034-4.252-21.034Z",
    fill: "url(#linear-gradient-132)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3191",
    "data-name": "Path 3191",
    d: "M-756.893,3193.67s4.5,36.939,7.276,58.86c.367,2.894-11.293,27.007-16.528,37.019-3.2,6.136,26.611,11.348,26.528-6.926s-3.328-27.56-5.275-37.446c-2.41-12.232-3.2-53.641-3.2-53.641Z",
    fill: "url(#linear-gradient-133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3192",
    "data-name": "Path 3192",
    d: "M-762.277,3294.31l-.421,4.7s-5.932,13.888-9.507,17.52c0,0-2.7,11.6-8.925,14.408a62.529,62.529,0,0,0,7.838-14.837C-770.572,3308.17-762.277,3294.31-762.277,3294.31Z",
    fill: "url(#linear-gradient-134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3193",
    "data-name": "Path 3193",
    d: "M-754.489,3298.43s-5.148,17.522-5.675,18.28,3.288,9.488,3.533,9.938,7.962,5.384,9.042,8.863c0,0,1.2-1.148-.6-3.712a23.856,23.856,0,0,0-6.783-6s-.53-5.017-3.02-8.133c0,0,3.333-3.114,4.288-10.208Z",
    fill: "url(#linear-gradient-135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3194",
    "data-name": "Path 3194",
    d: "M-744.975,3295.11l2.208,6.734s.445,11.255-1.234,16.221c0,0,12.113,6.7,11.723,12.186,0,0-2.553-4.551-13.186-11.564C-745.464,3318.69-745,3299.91-744.975,3295.11Z",
    fill: "url(#linear-gradient-136)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M-781.752,3324.2c.2-.438,2.323-.671,1.633,2.349s-1.273,3.8-1.564,4.048-2.672.869-2.22-.764a44.96,44.96,0,0,1,2.151-5.633Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M-754.653,3334.75c-.408-.253-.348-2.393,2.55-1.3s3.585,1.78,3.8,2.1.495,2.765-1.061,2.094a44.753,44.753,0,0,1-5.289-2.894Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3197",
    "data-name": "Path 3197",
    d: "M-738.632,3329.86c-.408-.253-.347-2.393,2.55-1.3s3.585,1.781,3.8,2.1.495,2.765-1.06,2.094A44.963,44.963,0,0,1-738.632,3329.86Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3198",
    "data-name": "Path 3198",
    d: "M-725.333,3323.02c-.364-.225-.31-2.134,2.274-1.156s3.2,1.588,3.386,1.877.442,2.466-.946,1.868A40.022,40.022,0,0,1-725.333,3323.02Z",
    fill: "#ffdebd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctors05);
export default __webpack_public_path__ + "static/media/Doctors 05.9e6edb46f45f3ac2fd83d37224bd7cc3.svg";
export { ForwardRef as ReactComponent };